import { axiosService } from "./axiosService";

const timesheetApi = {
    getTimesheet(id, params) {
        const url = `/timesheet/${id}`;
        return axiosService.get(url, {params})
    },
    createTimesheet(body) {
        const url = '/timesheet';
        return axiosService.post(url, body)
    },
    updateTimesheet(id, body) {
        const url = `/timesheet/${id}`;
        return axiosService.put(url, body)
    },
    getDetailTimeSheet(id) {
        const url = `/get-detail-timeSheet/${id}`;
        return axiosService.get(url);
    }
}

export default timesheetApi;